<template>
  <img
    :width="width"
    :height="height"
    :src="getPlaceholderIllustrations()">
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: '100'
    },
    height: {
      type: String,
      default: '100'
    }
  },
  data () {
    return {
      placeholderIllustrations: [`${import.meta.env.VITE_WEBSITE_IMAGES_URL}look-s.png`, `${import.meta.env.VITE_WEBSITE_IMAGES_URL}look2-s.png`]
    }
  },
  methods: {
    getPlaceholderIllustrations () {
      return this.placeholderIllustrations[Math.round(Math.random()) * (this.placeholderIllustrations.length - 1)]
    }
  }
}
</script>
